/*
 * @Author: lijing
 * @Date: 2022-09-05 17:45:51
 * @Last Modified by: lijing
 * @Last Modified time: 2022-10-28 17:12:55
 */

import React, { useState, FC, useEffect } from "react";
import { Form, Input, Select, Button, Table, Space, Modal, Row, Col } from "antd";
import type { ColumnsType } from "antd/es/table";
import {
  EditorLucturer,
  ILecturerDetailProp,
} from "./components/EditorLucturer";
import { teacherList, getTeacher, deleteTeacher } from "../../common/service";
import { useSelector } from "react-redux";
import { RootState } from "@root/store/index";
import { SubjectSelect, TitleSelect, HospitalSelect } from '@root/components/selectBox/index';

const { Option } = Select;
interface DataType {
  createBy: string;
  createTime: string;
  id: number;
  imageUrl: string;
  instituteId: number;
  introduction: string;
  mobile: string;
  name: string;
  showOrder: number;
  status: number;
  subjectId: number;
  subjectName: string;
  titleId: number;
  titleName: string;
  updateTime: string;
  workUnitId: number;
}

const LecturerManage: FC = () => {
  const columns: ColumnsType<DataType> = [
    {
      title: "姓名",
      dataIndex: "name",
      key: "name",
      render: (text) => <a>{text}</a>,
    },
    {
      title: "工作单位",
      dataIndex: "workUnitName",
      key: "workUnitName",
    },
    {
      title: "专业",
      dataIndex: "subjectName",
      key: "subjectName",
    },
    {
      title: "职称",
      dataIndex: "titleName",
      key: "titleName",
    },
    {
      title: "操作",
      key: "address",
      width: 200,
      render: (_, record: DataType) => (
        <Space>
          <Button
            type="link"
            onClick={() => {
              onEditClickHandle(record);
            }}
          >
            编辑
          </Button>
          <Button
            type="link"
            onClick={() => {
              onDeleteClickHandle(record);
            }}
          >
            删除
          </Button>
        </Space>
      ),
    },
  ];

  const { instituteList = [] } = useSelector((state: RootState) => state.directionaries);

  const [form] = Form.useForm();

  const [lecturerList, setLecturerList] = useState<DataType[]>([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [tableTotal, setTableTotal] = useState(1);
  const [lecturerDetail, setLecturerDetail] =
    useState<ILecturerDetailProp | null>(null);
  const [tablePageNum, setTablePageNum] = useState(1);

  const getTeacherList = async (page = tablePageNum) => {
    const params = form.getFieldsValue();

    setTableLoading(true);
    setTablePageNum(page);
    teacherList({ pageNum: page, pageSize: 10 }, { ...params })
      .then((res) => {
        const {
          data: { rows, total },
        } = res;
        setLecturerList(rows);
        setTableTotal(total);
      })
      .finally(() => {
        setTableLoading(false);
      });
  };

  const onSearchClickHandle = () => {
    getTeacherList(1);
  };

  const onResetClickHandle = () => {
    form.setFieldsValue({
      name: "",
      workUnitId: undefined,
      subjectId: undefined,
      titleId: undefined,
    });

    getTeacherList(1);
  };

  const onEditClickHandle = (data: DataType) => {
    setTableLoading(true);
    getTeacher(data.id)
      .then((res) => {
        setLecturerDetail(res.data);
        setIsModalVisible(true);
      })
      .finally(() => {
        setTableLoading(false);
      });
  };

  const onDeleteClickHandle = (data: DataType) => {
    Modal.confirm({
      title: "删除确认",
      content: "您确定删除吗？",
      okText: "确认",
      cancelText: "取消",
      onOk() {
        return new Promise((resolve, reject) => {
          deleteTeacher(data.id)
            .then((res) => {
              getTeacherList();
              resolve("删除成功");
            })
            .catch();
        }).catch(() => console.log("Oops errors!"));
      },
    });
  };

  useEffect(() => {
    getTeacherList();
  }, []);

  return (
    <div className="lecturermanage">
      <div className="lecturemanage-query">
        <Form form={form}
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
        >
          <Row>
            <Col span={6}>
              <Form.Item label="姓名" name="name">
                <Input placeholder="请输入姓名" />
              </Form.Item>
            </Col>
            <Col span={6}>
              <HospitalSelect label="工作单位"
                name="workUnitId"
              />
            </Col>
            <Col span={6}>
              <SubjectSelect
                label="学科"
                name="subjectId"
              />
            </Col>
            <Col span={6}>
              <TitleSelect
                label="职称"
                name="titleId"
              />
            </Col>
          </Row>
          <Row>
            <Col span={24} style={{ textAlign: 'right' }}>
              <Space>
                <Button
                  type="primary"
                  onClick={() => {
                    onSearchClickHandle();
                  }}
                >
                  查询
                </Button>
                <Button
                  onClick={() => {
                    onResetClickHandle();
                  }}
                >
                  重置
                </Button>
              </Space>
            </Col>
          </Row>
        </Form>
      </div>
      <div className="lecturermanage-btns">
        <Button
          type="primary"
          onClick={() => {
            setLecturerDetail(null);
            setIsModalVisible(true);
          }}
        >
          新建讲师
        </Button>
      </div>
      <div className="lecturermanage-tables">
        <Table
          rowKey="id"
          columns={columns}
          dataSource={lecturerList}
          loading={tableLoading}
          pagination={{
            total: tableTotal,
            onChange: (page) => {
              getTeacherList(page);
            },
            showTotal: (total, range) => {
              return "共" + tableTotal + "条记录";
            },
          }}
        />
      </div>
      {isModalVisible && (
        <EditorLucturer
          setIsModalVisible={setIsModalVisible}
          lecturerDetail={lecturerDetail as ILecturerDetailProp}
          getTeacherList={getTeacherList}
        />
      )}
    </div>
  );
};

export default LecturerManage;
